import React, { useEffect, useState } from "react";
import InputBar from "../../components/DriverAssets/InputBar";
import MedalsList from "../../components/DriverMedals/MedalsList";
import MetricsList from "../../components/DriverMedals/MetricList";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import HorizontalTabs from "sushiweb/HorizontalTabs";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverMedalsActions from "../../store/actions/DriverMedals";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";

const DriverMedals = (props) => {
  const {
    getDriverMedalsDetails,
    getDriverMetaData,
    driverMedalsList,
    driverMetricsList,
  } = props;
  const [activeIndex, setActiveIndex] = useState("Medals");
  const allActions = MenuActionsMappings[MenuNames.DRIVER_MEDALS];

  const handleCredsChange = (states) => {
    const payload = {};
    Object.keys(states).map((key) => {
      if (states[key] !== "") {
        payload[key] = states[key];
      }
    });
    if (payload["driver_id"]) {
      getDriverMedalsDetails({ driver_id: payload["driver_id"] });
    } else {
      getDriverMetaData(payload).then((res) => {
        if (res) {
          getDriverMedalsDetails({ driver_id: res.driver_id });
        }
      });
    }
  };

  const handleClick = (tabName) => {
    setActiveIndex(tabName);
  };

  return (
    <div className="Driver-Assets-View container">
      <Heading>Driver Medals</Heading>
      <InputBar
        permissions={[allActions.METRIC_DETAILS]}
        handleSubmit={handleCredsChange}
      />
      <HorizontalTabs id="sushi-tabs" className="mb-20" alignLinks="left">
        {["Medals", "Metrics"].map((tab, index) => {
          return (
            <HorizontalTabs.Link
              active={activeIndex == tab}
              onClick={() => handleClick(tab)}
              key={index}
              className={`rider_medal_tab${index}${activeIndex === tab}`}
            >
              {tab}
            </HorizontalTabs.Link>
          );
        })}
      </HorizontalTabs>
      <>
        {activeIndex === "Medals" ? (
          <MedalsList list={driverMedalsList} />
        ) : (
          <MetricsList list={driverMetricsList} />
        )}
      </>
    </div>
  );
};

function mapStateToProps(state) {
  const { DriverMedals } = state;
  return {
    driverMedalsList: DriverMedals.driverMedalsList,
    driverMetricsList: DriverMedals.driverMetricsList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverMedalsDetails: bindActionCreators(
      DriverMedalsActions.getDriverMedalsDetails,
      dispatch
    ),
    getDriverMetaData: bindActionCreators(
      DriverMedalsActions.getDriverMetaData,
      dispatch
    ),
    resetState: bindActionCreators(DriverMedalsActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverMedals);
